export const EVENTS = {
    READY: 'rvlife-mfe:ready',
    PROCESSING: 'rvlife-mfe:processing',
    CLOSE: 'rvlife-mfe:close',
}